var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-coa-item"},[_c('div',{staticClass:"c-coa-item__label"},[(_vm.label)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._t("label")],2),_c('p',{staticClass:"c-coa-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }